// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"61c08605","648":"f0c3bc2f","747":"a67a5b1a","970":"4c81ee05"}[chunkId] + ".chunk.css";
};